import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';              // ✅ for ngModel
import { HttpClientModule } from '@angular/common/http';   // ✅ for HttpClient

import { PhoneDialerRoutingModule } from './phone-dialer-routing.module';
import { PhoneDialerComponent } from './phone-dialer.component';
import { TwilloDialerComponent } from './twillo-dialer/twillo-dialer.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    PhoneDialerComponent,
    TwilloDialerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,           // ✅ add here
    HttpClientModule,      // ✅ add here
    PhoneDialerRoutingModule,
    MatIconModule
  ],
  exports:[PhoneDialerComponent, TwilloDialerComponent]
})
export class PhoneDialerModule { }
